import React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const CommonButton = React.forwardRef(({ 
  className, 
  variant = 'default', 
  size = 'default', 
  children, 
  icon: Icon,
  iconPosition = 'left',
  loading = false,
  ...props 
}, ref) => {
  const roundedClass = 
    size === 'sm' || size === 'icon-sm' ? 'rounded-[6px]' : 
    size === 'default' || size === 'icon' ? 'rounded-[8px]' : 
    'rounded-[10px]';

  const iconSizeClass = 
    size === 'sm' || size === 'icon-sm' ? 'h-3 w-3' : 
    size === 'default' || size === 'icon' ? 'h-3.5 w-3.5' : 
    'h-4 w-4';

  const marginClass = 
    size === 'sm' || size === 'icon-sm' || size === 'default' || size === 'icon' ? 'mr-1.5' : 
    'mr-2';

  const mlMarginClass = 
    size === 'sm' || size === 'icon-sm' || size === 'default' || size === 'icon' ? 'ml-1.5' : 
    'ml-2';

  return (
    <Button
      ref={ref}
      className={cn(
        'transition-all duration-200 font-medium active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed',
        roundedClass,
        className
      )}
      variant={variant}
      size={size}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading ? (
        <div className="animate-spin rounded-full h-4 w-4 border-2 border-current border-t-transparent mr-2" />
      ) : (
        Icon && iconPosition === 'left' && <Icon className={cn(marginClass, iconSizeClass)} />
      )}
      {children}
      {!loading && Icon && iconPosition === 'right' && <Icon className={cn(mlMarginClass, iconSizeClass)} />}
    </Button>
  );
});

CommonButton.displayName = 'CommonButton';

export { CommonButton };